export const WIKI_DOCS = '/docs/default/component/legacy-wiki';

const SECTION_NAMES = [
  'Development',
  'QA',
  'Production',
  'Support',
  'Investment',
  'B2B',
  'HOWTOS',
  'Miscellaneous',
  'BAU',
  'Architecture',
  'Batches',
];

export const WIKI_SECTIONS = SECTION_NAMES.map(name => ({
  name,
  docsPath: `${WIKI_DOCS}/${name.toLowerCase()}/`,
}));
